<template>
  <div>
    <div class="mb-2"><strong>Dates</strong></div>
    <div v-if="!saving">
      <div v-for="date in dates" :key="'date'+date.id" class="mb-3">
        <div>
          <strong>{{date.date}}</strong> - {{date.name}}
          <b-button class="mx-4" variant="outline-primary" size="sm" v-on:click="editStart(date)">edit</b-button>
          <b-button class="mr-2" variant="outline-primary" size="sm" v-on:click="remove(date.id)">remove</b-button>
        </div>
      </div>
      <div>
        <b-form-input id="inputDate"
          v-model="dateInput"
          type="date"
          required
          class="mb-2">
        </b-form-input>
        <b-form-input id="inputName"
          v-model="nameInput"
          placeholder="Free text"
          required
          class="mb-2">
        </b-form-input>
      </div>
      <b-button v-if="validate" class="mr-2" variant="primary" size="sm" v-on:click="save">Save</b-button>
      <b-button v-if="nameInput" variant="outline-primary" size="sm" v-on:click="cancel">Cancel</b-button>
    </div>
    <span v-if="saving">
      <i class="fa fa-spinner fa-pulse fa-lg fa-fw"></i>
    </span>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'DatesComponent',
  props: ['model', 'parentId', 'property'],
  computed: {
    user: {
      get () {
        return this.$store.state.user
      }
    },
    validate: function () {
      return this.nameInput && moment(this.dateInput).isValid()
    }
  },
  created: function () {
    this.load()
  },
  data () {
    return {
      edit: false,
      id: null,
      links: [],
      nameInput: null,
      saving: false,
      dateInput: null
    }
  },
  methods: {
    cancel: function () {
      this.nameInput = null
      this.dateInput = null
    },
    editStart: function (date) {
      this.id = date.id
      this.nameInput = date.name
      this.dateInput = date.date
      this.edit = true
    },
    load: async function () {
      this.saving = true
      try {
        this.dates = await this.$Amplify.API.get('cosmos', `/standard/${this.model}/where/${this.property}/equal/${this.parentId}`)
      } catch (e) {
        this.$logger.warn(e)
      }
      this.saving = false
    },
    remove: async function (id) {
      this.saving = true
      try {
        await this.$Amplify.API.del('cosmos', `/standard/${this.model}/${id}`)
        const dates = this.dates
        _.remove(dates, x => x.id === id)
        this.dates = dates
      } catch (e) {
        this.$logger.warn('event saving error: ' + e)
      }
      this.saving = false
    },
    save: async function () {
      this.$logger.debug(`saving start`)
      this.saving = true
      try {
        // let response = await this.$http(config)
        const body = {
          name: this.nameInput,
          date: moment(this.dateInput).format('YYYY-MM-DD')
        }
        body[this.property] = this.parentId
        let params = {
          body: body
        }
        let response
        if (this.edit) {
          await this.$Amplify.API.put('cosmos', `/standard/${this.model}/${this.id}`, params)
          const newItem = {
            id: this.id,
            name: this.nameInput,
            date: this.dateInput
          }
          const dates = this.dates
          _.remove(dates, x => x.id === this.id)
          dates.push(newItem)
          this.dates = dates
        } else {
          response = await this.$Amplify.API.put('cosmos', `/standard/${this.model}`, params)
          this.dates.push(response)
        }
        this.cancel()
      } catch (e) {
        this.$logger.warn('event saving error: ' + e)
      }
      this.edit = false
      this.id = null
      this.saving = false
    }
  }
}
</script>

<style>
</style>
